<form [formGroup]="kpiForm">
    <div class="top-line flex-h field-w-100" >         
        <div class="col-gauge">
            <div class="gauge-chart" (window:resize)="resizeGauge()">
                <ngx-gauge [type]="gaugeType" *ngIf="showGauge"
                            [value]="gaugeValue" 
                            [label]="gaugeLabel"
                            [size]="gaugeSize"
                            foregroundColor="#17A5E3"
                            [ngClass]="{'gauge-m': gaugeSize >= 160, 'alert-color': isExpectationNotMet}"
                            [append]="gaugeAppendText">
                </ngx-gauge>
            </div>
        </div>
        <div class="col-fields">
            <div class="field-name name-row">
                <app-search title="{{ 'GOAL_KPI_EDIT.GOAL_SPECIFICATION' | translate }}"
                    class="label-color-secondary"
                    #search
                    formControlName="name"
                    controlType="textarea"
                    appearance="outline"
                    [showSearchIcon]="false"
                    [matTooltip]="kpi.name"
                    (change)="onSearchChange($event)"
                    (blur)="onBlur($event)"
                    [rows]="2"
                    [disabled]="!isAllowEditBasicFields()"
                    [inlineButtons]="false"
                    [isAllowSearch]="true"
                    [showAddButton]="false"
                    [isCustomAdd]="false"
                    [multilineDropdown]="true"
                    [config]="kpiSearchConfig"></app-search>
            
                <div class="field-completion-logic">
                    <mat-form-field appearance="outline" class="no-width completion-logic-field field-m">
                        <mat-label>{{ 'GOAL_KPI_EDIT.GOAL_ACHIEVEMENT_CONDITION' | translate }}</mat-label>
                        <mat-select formControlName="calculationType" disableOptionCentering class="drop-fix multi-line">
                            <mat-option *ngFor="let option of completionLogicOptions" [value]="option.value" [matTooltip]="option.tooltip | translate">
                                {{ option.text | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="value-fields">
                <div class="line1">
                    <mat-form-field appearance="outline" class="no-width input-m label-color-secondary field-value">
                        <mat-label>{{ 'GOAL_KPI_EDIT.PLANNED_RESULT' | translate }}</mat-label>
                        <input matInput formControlName="planned" decimalMarker="," mask="separator.3" [allowNegativeNumbers]="false"  [ngStyle]="{'font-size': getInputSize('planned') }" (blur)="onBlur($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="no-width input-m label-color-secondary field-value">
                        <mat-label>{{ 'GOAL_KPI_EDIT.UNIT' | translate }}</mat-label>
                        <input matInput formControlName="unit" required (input)="changeUnit($event)" (blur)="onBlur($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="no-width input-m field-inverted field-value">
                        <mat-label>{{ 'GOAL_KPI_EDIT.ACHIEVED_RESULT' | translate }}</mat-label>
                        <input matInput formControlName="achieved" decimalMarker="," mask="separator.3" [allowNegativeNumbers]="true" (blur)="onBlur($event)">
                    </mat-form-field>
                </div>
                <div class="line2">
                    <mat-form-field appearance="outline" class="field-deadline input-m">
                        <mat-label>{{ 'GOAL_KPI_EDIT.DEADLINE' | translate }}</mat-label>
                        <mat-select formControlName="deadline" disableOptionCentering class="drop-fix">
                            <mat-option [value]="null">-</mat-option>
                            <mat-option *ngFor="let item of months" [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="field-weight">
                        <mat-form-field appearance="outline" class="no-width weight-field input-m">
                            <mat-label>{{ 'GOAL_KPI_EDIT.WEIGHTING' | translate }}</mat-label>
                            <input matInput type="number" inputmode="numeric" max="100" formControlName="weight" title="Súlyozás érték: üres, vagy 1-100%">
                        </mat-form-field>
                    </div>
                    <div class="field-min-expectaion">
                        <mat-form-field appearance="outline" class="no-width exp-field field-m input-m">
                            <mat-label>{{ 'GOAL_KPI_EDIT.MIN_EXPECTATION_PERCENT' | translate }}</mat-label>
                            <input matInput type="number" formControlName="minExpectation">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div *ngIf="hasPlannedLessThanMinError" class="error-message">
                    {{ plannedLessThanMinErrorMessage }}
            </div>
        </div>
        <div class="col-actions">
            <button mat-icon-button color="primary" class="kpi-delete hidden-print icon-button" [disabled]="!allowDelete()" (click)="deleteKPI()" title="{{ 'GOAL_KPI_EDIT.DELETE_KPI' | translate }}">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>

    <div class="comment-block">
        <div class="comment-title">{{ 'GOAL_KPI_EDIT.COMMENTS' | translate }}</div>
        <div class="comment-content">
            <div class="comment-section">
                <app-comment-section [config]="createCommentConfig(kpi)" [comments]="kpi.comments"
                        [isEditable]="false"
                        [isShowDeleteButton]="false"
                        [isAutoSave]="false"
                        [singleComments]="true"
                        [isCommentHeaderVisible]="true"
                        displayStyle="style-3"
                ></app-comment-section>
            </div>
            <div class="button-group">
                <button mat-flat-button class="lg-button2 sm-text button-bg-alt4" [disabled]="!allowComment()" (click)="showCommentDialog()" title="{{ 'GENERAL.EDIT_COMMENT_TITLE' | translate }}" [innerHTML]="'GENERAL.EDIT_COMMENT' | translate"></button>
            </div>
        </div>
    </div>
</form>
<div>
    <app-audit-line [data]="kpi"></app-audit-line>
</div>
